export const formatStringOnlyNumbers = (value: string) => value.replace(/\D/g, '');

export default formatStringOnlyNumbers;
